
export const localGetItem = ({key, type}) => {
	const data = window.localStorage.getItem(key);
	if(data) {
		if(!type) {
			return JSON.parse(data)
		}
		return data
	}
	return "";
}
